import { TabNames } from '@/pages-v2/home/storeList/component/StoreTabs/constants'
import VueI18n from '@/i18n/locale'
import { getList, getAreaList } from './service'
import { getBDCountry } from '@/common/utils/i18n'

const country = getBDCountry() || 'MX'

// 排除的参数
export const exceptFilterKey = {
  [TabNames.priority.key]: [
    'notMyStore', // 标记-非我负责的门店【只传商圈】
    'followUpStatus',
  ],
  [TabNames.area.key]: [
    'type', // 门店类型 【商圈不传】
    'followUpStatus', // 跟进状态【只传BR巴西】
  ],
  [TabNames.my.key]: [
    'notMyStore', // 标记-非我负责的门店【只传商圈】
    'followUpStatus', // 跟进状态【只传BR巴西】
  ],
  [TabNames.all.key]: [
    'notMyStore', // 标记-非我负责的门店【只传商圈】
    'followUpStatus', // 跟进状态【只传BR巴西】
  ],
}

// 排除的参数（BR巴西）
export const exceptFilterKeyBR = {
  [TabNames.rtbo.key]: [
    'notMyStore', // 标记-非我负责的门店【只传商圈】
  ],
  [TabNames.priority.key]: [
    'notMyStore', // 标记-非我负责的门店【只传商圈】
  ],
  [TabNames.area.key]: [
    'type', // 门店类型 【商圈不传】
  ],
  [TabNames.my.key]: [
    'notMyStore', // 标记-非我负责的门店【只传商圈】
  ],
  [TabNames.all.key]: [
    'notMyStore', // 标记-非我负责的门店【只传商圈】
  ],
}

export const requestTypeMap = {
  [TabNames.rtbo.key]: 5,
  [TabNames.priority.key]: 3,
  [TabNames.area.key]: 4,
  [TabNames.my.key]: country === 'BR' ? 7 : 2,
  [TabNames.all.key]: 1,
}

export const requesterMap = {
  [TabNames.rtbo.key]: getList,
  [TabNames.priority.key]: getList,
  [TabNames.area.key]: getAreaList,
  [TabNames.my.key]: getList,
  [TabNames.all.key]: getList,
}
export const cityOptionsMap = {
  [TabNames.rtbo.key]: 'cityIds',
  [TabNames.priority.key]: 'cityIds',
  [TabNames.area.key]: 'areaCityIds',
  [TabNames.my.key]: 'cityIds',
  [TabNames.all.key]: 'cityIds',
}

export const cityValuesMap = {
  [TabNames.rtbo.key]: ['cityId', 'bdAreaIds'],
  [TabNames.priority.key]: ['cityId', 'bdAreaIds'],
  [TabNames.area.key]: ['AreaCityId', 'AreaAreaIds'],
  [TabNames.my.key]: ['cityId', 'bdAreaIds'],
  [TabNames.all.key]: ['cityId', 'bdAreaIds'],
}

export const CityAndAreaKeyMap = {
  cityId: 'cityId',
  AreaCityId: 'cityId',
  bdAreaIds: 'bdAreaIds',
  AreaAreaIds: 'bdAreaIds',
}
const COMMON_SORT_TYPE_ENUM = [
  {
    value: 0,
    label: `${VueI18n.t('FoodB_202207_Default_BQmA' /** 默认 */)} (${VueI18n.t(
      'Gattaran_Page_Distance_jPzG' /** 距离 */,
    )})`,
  },
  {
    value: 4,
    label: `${VueI18n.t('FoodB_0830__wEQD' /** 本月完单量 */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */,
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`,
  },
  {
    value: 3,
    label: `${VueI18n.t('FoodB_0830__wEQD' /** 本月完单量 */)} (${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */,
    )}→${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)})`,
  },
  {
    value: 6,
    label: `${VueI18n.t('FoodB_P0_cNyW_HkyE' /** 完单变化量 */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */,
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`,
  },
  {
    value: 5,
    label: `${VueI18n.t('FoodB_P0_cNyW_HkyE' /** 完单变化量 */)} (${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */,
    )}→${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)})`,
  },
  {
    value: 8,
    label: `${VueI18n.t('FoodB_V1_raHO_jXSF' /** 本月R burn/GMV */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */,
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`,
  },
  {
    value: 7,
    label: `${VueI18n.t('FoodB_V1_raHO_jXSF' /** 本月R burn/GMV */)} (${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */,
    )}→${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)})`,
  },
  {
    value: 10,
    label: `${VueI18n.t('FoodB_V1_zPrX_zWoE' /** R burn/GMV变化量 */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */,
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`,
  },
  {
    value: 9,
    label: `${VueI18n.t('FoodB_V1_zPrX_zWoE' /** R burn/GMV变化量 */)} (${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */,
    )}→${VueI18n.t('Gattaran_Feedback__amKQ' /** 低 */)})`,
  },
  {
    value: 16,
    label: `${VueI18n.t('FoodB_score_lThf_wlQT' /** 商家健康分 */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */,
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`,
  },
  {
    value: 17,
    label: `${VueI18n.t('FoodB_score_lThf_wlQT' /** 商家健康分 */)} (${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */,
    )}→${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)})`,
  },
]
export const sortTypeEnum = [...COMMON_SORT_TYPE_ENUM]
// 是否判定BR才显示特征
export const sortTypeEnumBR = [
  ...COMMON_SORT_TYPE_ENUM,
  {
    value: 13,
    label: `${VueI18n.t('FoodB_scenario_cDgW_SOLZ' /** 近7日B责取消率 */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */,
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`,
  },
  {
    value: 12,
    label: `${VueI18n.t('FoodB_scenario_cDgW_SOLZ' /** 近7日B责取消率 */)} (${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */,
    )}→${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)})`,
  },
  {
    value: 15,
    label: `${VueI18n.t('FoodB_scenario_DYVH_kYTv' /** 近7日B责取消单量 */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */,
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`,
  },
  {
    value: 14,
    label: `${VueI18n.t('FoodB_scenario_DYVH_kYTv' /** 近7日B责取消单量 */)} (${VueI18n.t(
      'Gattaran_Feedback__urHD' /** 低 */,
    )}→${VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */)})`,
  },
]
